/**
 * The Individual row for line items on the bill credit detail view
 */
import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import TableCell from '../ReusableComponents/Table/TableCell';
import TableRow from '../ReusableComponents/Table/TableRow';

function PaymentRow({ payment }) {
  return (
    <TableRow>
      <TableCell size="small" scope="row" align="center">
        {moment(payment.invoice_date, 'YYYY-MM-DD').format('MM/DD/YYYY')}
      </TableCell>
      <TableCell size="medium" align="center">
        {payment.invoice_number}
      </TableCell>
      <TableCell align="left">{payment.description}</TableCell>
      <TableCell align="right">
        {numeral(payment.original_amount).format('$0,0.00')}
      </TableCell>
      <TableCell align="right">
        {numeral(payment.amount_due).format('$0,0.00')}
      </TableCell>
      <TableCell align="right">
        {numeral(payment.discount).format('$0,0.00')}
      </TableCell>
      <TableCell align="right">
        {numeral(payment.payment).format('$0,0.00')}
      </TableCell>
    </TableRow>
  );
}

PaymentRow.propTypes = {
  payment: PropTypes.shape({
    invoice_date: PropTypes.string,
    description: PropTypes.string,
    original_amount: PropTypes.number,
    amount_due: PropTypes.number,
    discount_taken: PropTypes.number,
    amount: PropTypes.number,
  }).isRequired,
};

export default PaymentRow;
